import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.2 21.51q-.908 0-1.553-.697A2.38 2.38 0 0 1 1 19.135v-4.75q.908 0 1.554-.699A2.38 2.38 0 0 0 3.2 12.01q0-.98-.646-1.678Q1.908 9.635 1 9.635v-4.75q0-.98.647-1.677.645-.699 1.553-.698h17.6q.908 0 1.554.698A2.38 2.38 0 0 1 23 4.885v14.25q0 .98-.646 1.678-.646.696-1.554.697z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M16.5 17.51H7"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M17.292 12.299 7.913 14.97a.5.5 0 0 1-.357-.016.62.62 0 0 1-.276-.252L6.1 12.477q-.165-.327-.055-.624a.6.6 0 0 1 .44-.386.47.47 0 0 1 .233 0q.125.03.207.09l1.183.98 2.64-.713-2.063-3.919q-.22-.445-.082-.831.137-.387.604-.535a.7.7 0 0 1 .4 0q.205.06.343.208l4.098 4.127 2.694-.772a.95.95 0 0 1 .784.103q.372.223.482.669.109.445-.097.875-.205.43-.619.55"
    }, null, -1)
  ])))
}
export default { render: render }